module.exports = __webpack_public_path__ + "static/assets/9fdc34c247ad319851362398b5e4e255.svg";